<template>
  <alzata-odata-table
    ref="usersGrid"
    clickable
    title="Users"
    endpoint="/api/v1/users"
    :columns="[
      {
        id: 'DisplayName',
        label: 'Name',
        sortable: true,
      },
      {
        id: 'Email',
        label: 'Email',
        sortable: true,
      },
      {
        id: 'LastLogin',
        label: 'Last Login',
        sortable: true,
      },
      {
        id: 'Roles',
        label: 'Roles',
        sortable: false,
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: show,
      },
    ]"
  >
    <template v-slot:format-first-name="{ item }">
      <div>
        <div>{{ item.firstName }} {{ item.lastName }}</div>
        <div class="small text-muted">{{ item.email }}</div>
      </div>
    </template>
    <template v-slot:format-roles="{ item }">
      {{ item.roles.sort().join(", ") }}
    </template>
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="show({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add User
      </button>
    </template>
  </alzata-odata-table>
  <alzata-edit-user-dialog ref="editUserDialog" @save="saveUser" />
</template>

<script>
import { mapActions } from "vuex";

function isValidEmail(email) {
  // use a regular expression to test if the email address is in the correct format
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(email);
}

export default {
  name: "AlzataUserList",
  methods: {
    show(user) {
      console.log("show", user);
      this.$refs.editUserDialog.show(user);
    },
    async saveUser(user) {
      if (!isValidEmail(user.email)) {
        alert("Invalid email address");
        return;
      }

      const body = {
        userName: user.userName,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phoneNumber: user.phoneNumber,
        roles: user.roles,
      };

      if (user.id) {
        const res = await this.apiClient.postJson(`/api/v1/user/${user.id}`, {
          body,
        });
        if (!res.id) {
          alert("error saving user");
          return;
        }
      } else {
        const res = await this.apiClient.postJson("/api/v1/user", { body });
        if (!res.success) {
          alert("error creating user");
          return;
        }
        user.id = res.id;
      }

      this.$refs.usersGrid.reload();
      this.getAuthenticationStatus();
      this.$refs.editUserDialog.hide();
    },
    ...mapActions("iam", ["getAuthenticationStatus"]),
  },
};
</script>
